export default __webpack_public_path__ + "static/media/1stBlog.b28407ed.jpg";